import React from 'react'
import IconBase from 'components/atoms/IconBase/IconBase'

interface Props {
  className?: string
}

function RadioMarked({ className }: Props) {
  return (
    <IconBase name="radio-marked" w={24} className={className}>
      <rect x="4" y="4" width="16" height="16" rx="8" strokeWidth="2" fill="none"/>
      <rect x="7" y="7" width="10" height="10" rx="5" stroke="none"/>
    </IconBase>
  )
}

export default RadioMarked
